import { Directive, ElementRef, HostListener } from '@angular/core';
import { KEY_CODE } from '../enum/base.enum';

@Directive({
  selector: '[appNumber]'
})


export class NumberDirective {
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Delete', 'Ctrl'];

  constructor(private el: ElementRef) { }
  private regex: RegExp = new RegExp('^[0-9]+$');
  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent) {
    // if (this.specialKeys.indexOf(event.key) !== -1) {
    //   return;
    // }
    if (
      // Allow: Delete, Backspace, Tab, Escape, Enter
      [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 || 
      (e.keyCode === KEY_CODE.Ctrl_A && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.keyCode === KEY_CODE.Ctrl_C && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.keyCode === KEY_CODE.Ctrl_V && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.keyCode === KEY_CODE.Ctrl_X && e.ctrlKey === true) || // Allow: Ctrl+X
      (e.keyCode === KEY_CODE.Ctrl_A && e.metaKey === true) || // Cmd+A (Mac)
      (e.keyCode === KEY_CODE.Ctrl_C && e.metaKey === true) || // Cmd+C (Mac)
      (e.keyCode === KEY_CODE.Ctrl_V && e.metaKey === true) || // Cmd+V (Mac)
      (e.keyCode === KEY_CODE.Ctrl_X && e.metaKey === true) || // Cmd+X (Mac)
      (e.keyCode >= KEY_CODE.Home && e.keyCode <= KEY_CODE.Right) // Home, End, Left, Right
    ) {
      return;  // let it happen, don't do anything
    }
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(e.key);
    if (next && !String(next).match(this.regex)) {
      e.preventDefault();
    }
  }
  @HostListener('wheel', ['$event']) wheel(e: any) {
    e.preventDefault();
  }
}